<template>
	<div class="table-div">
		<div class="th-div">
			<div class="flex-1">{{ $t('币种') }}</div>
			<div class="flex-1">{{ $t('权益') }}</div>
			<div class="flex-1">{{ $t('占比') }}</div>
			<div class="flex-1">{{ $t('冻结') }}</div>
			<div class="w10 txt-ali-cen">{{ $t('操作') }}</div>
		</div>

		<div class="tr-div" v-for="item in list" :key="item.id">
			<div class="flex-1 td1">
				<img :src="item.image">
				<div class="txt-div">
					<div>{{ item.symbol }}</div>
					<div class="brief">{{ item.title }}</div>
				</div>
			</div>
			<div class="flex-1 td2">
				<div>{{ item.value }}</div>
				<div class="brief">${{ item.usdt_value }}</div>
			</div>
			<div class="flex-1 td3"> {{ item.percent }}%</div>
			<div class="flex-1 td4">{{ item.lock }}</div>

			<div class="w10 td5 txt-ali-cen cur-poi" @click="$nav.go('/pc/trade?code=' + item.symbol)">{{ $t('交易') }}</div>
			<!-- <div class="w10 td5 txt-ali-cen">
				<el-dropdown>
					<i class="cur-poi">
						<svg focusable="false" data-icon="ellipsis" width="26" height="26" fill="currentColor"
							aria-hidden="true" viewBox="64 64 896 896">
							<path
								d="M176 511a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0zm280 0a56 56 0 10112 0 56 56 0 10-112 0z">
							</path>
						</svg>
					</i>
					<template #dropdown>
						<el-dropdown-menu class="user-dropdown-menu">
							<el-dropdown-item>{{ $t('交易') }}</el-dropdown-item>
							<el-dropdown-item>{{ $t('划转') }}</el-dropdown-item>
						</el-dropdown-menu>
					</template>
</el-dropdown>
</div> -->
		</div>
	</div>
</template>

<script>
export default {
	props: {
		list: {
			type: Array,
			default: () => []
		},
	},
	components: {},
	data() {
		return {};
	},
	mounted() { },

	methods: {}
};
</script>
<style lang="scss" scoped>
.table-div {
	height: 650px;
	overflow-y: auto;

	.th-div {
		display: flex;
		align-items: center;
		margin-bottom: 10px;
		color: #5e5e7a;
		font-size: 12px;
	}

	.tr-div {
		height: 80px;
		border-bottom: 1px solid #31323f;
		background: #000;
		display: flex;
		align-items: center;
		font-size: 16px;

		.td1 {
			display: flex;
			align-items: center;

			img {
				width: 34px;
				height: 34px;
			}

			.txt-div {
				margin-left: 10px;
				text-align: left;
			}
		}
	}

	.w10 {
		width: 10%;
	}

	.brief {
		color: #888;
		font-size: 12px;
	}
}
</style>